// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 335,
      y: 432,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '95d277a4-48d9-4457-89db-a8b0faa57854',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.217105
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Pop_Up_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: 'd309c07b-1cc1-4e36-8723-0a7cfe803a07',
      type: 'Sprite',
      name: 'bgHexagon',
      className: '',
      x: 0,
      y: -77,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Rewards_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '3ea77c8f-d952-4fb2-8f03-663b2fb4d5cf',
      type: 'Container',
      name: 'lostThingsContainer',
      className: '',
      x: 0,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '7368dc41-cb4c-49f9-b9c3-fe3c16ba7aa8',
      type: 'Container',
      name: 'bodyTextWrapper',
      className: '',
      x: 0,
      y: 27,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '290f9ddf-4ca7-4165-8698-25c9e73fe350',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 120,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Try Again?',
      localize: true,
      maxWidth: 320,
      maxHeight: 78,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fff3d9',
        stroke: '#712316',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      type: 'Sprite',
      name: 'header',
      className: '',
      x: 0,
      y: -332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Header',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '006b9d6a-e9a5-4507-986a-30b5098fc898',
      type: 'Sprite',
      name: 'replayButtonGroup',
      className: '',
      x: 8,
      y: 211,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Green_Button_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '69551968-9529-4083-9063-7d6a04eee1ba',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 266,
      y: -320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Home_Blue_Button',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '936cc7f0-cbed-40e4-9426-cc6f56a47abf',
      type: 'Container',
      name: 'heartContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ea77c8f-d952-4fb2-8f03-663b2fb4d5cf'
    },
    {
      id: '012b36e3-696e-45f8-bdd7-4af0d87334bf',
      type: 'Container',
      name: 'winStreakContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ea77c8f-d952-4fb2-8f03-663b2fb4d5cf'
    },
    {
      id: 'ae8f8024-c22b-4a1a-90a4-4c652b4c7dca',
      type: 'Text',
      name: 'bodyText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You lost a *life*!',
      localize: true,
      maxWidth: 400,
      maxHeight: 78,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fff3d9',
        stroke: '#712316',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 400,
        breakWords: false,
        lineHeight: 32,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7368dc41-cb4c-49f9-b9c3-fe3c16ba7aa8',
      stateByName: {
        unlimitedLives: {
          text: 'You\'ve currently got Unlimited Lives'
        }
      }
    },
    {
      id: '6110fb58-4e31-43e0-b59e-22367159183d',
      type: 'Text',
      name: 'title',
      className: 'upperCase_SPL',
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level Failed',
      localize: true,
      maxWidth: 414,
      maxHeight: 205,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '31c4b118-6d9a-49a2-bb99-3543ace30601'
    },
    {
      id: '012a0de5-e430-4b1d-b490-c95ba55a5dc6',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 181,
        y: 70
      },
      width: 362,
      height: 139,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: '006b9d6a-e9a5-4507-986a-30b5098fc898'
    },
    {
      id: '214759ff-2ac5-4486-a27a-8133ab6a4f35',
      type: 'Layout',
      name: 'replayButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '006b9d6a-e9a5-4507-986a-30b5098fc898',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'd8723fe2-dc57-4c1d-a821-c8b6cbf562fe',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '936cc7f0-cbed-40e4-9426-cc6f56a47abf'
    },
    {
      id: '2e765838-acb4-4eb2-beba-7b0cf4ed3c58',
      type: 'Sprite',
      name: 'bigHeart',
      className: '',
      x: 0,
      y: -19,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Broken_Heart_Icon',
      parent: '936cc7f0-cbed-40e4-9426-cc6f56a47abf',
      stateByName: {
        unlimitedLives: {
          texture: 'Big_Heart'
        }
      }
    },
    {
      id: 'a0f2eda5-511c-431a-929e-3f167c742476',
      type: 'Sprite',
      name: 'infinitySymbol',
      className: '',
      x: 0,
      y: -37,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Infinity_Symbol_Big',
      parent: '936cc7f0-cbed-40e4-9426-cc6f56a47abf',
      stateByName: {
        unlimitedLives: {
          visible: true
        }
      }
    },
    {
      id: '96ed95b6-c787-486b-acf2-3996a46b020e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '012b36e3-696e-45f8-bdd7-4af0d87334bf'
    },
    {
      id: 'dc63e890-5618-4634-bf4d-669eec229cf9',
      type: 'Container',
      name: 'winStreakIconSlot',
      className: '',
      x: 0,
      y: -19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '012b36e3-696e-45f8-bdd7-4af0d87334bf'
    },
    {
      id: 'ad8a1ffa-cf77-431d-aa09-d400be3a90b5',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Retry',
      localize: true,
      maxWidth: 294,
      maxHeight: 98,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eaffe5',
        stroke: '0x006f0d',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 294,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '214759ff-2ac5-4486-a27a-8133ab6a4f35'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'unlimitedLives'
  ],
  handleResize: false
} as const;

export class LoseLifePopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  background!: Sprite;
  bgHexagon!: Sprite;
  lostThingsContainer!: Container;
  bodyTextWrapper!: Container;
  header!: Sprite;
  replayButtonGroup!: Sprite;
  closeButton!: Sprite & { data: typeof raw['list'][9]['data'] };
  heartContainer!: Container;
  winStreakContainer!: Container;
  bodyText!: Text;
  title!: Text;
  replayButton!: ButtonLargeLayout & { data: typeof raw['list'][15]['data'] };
  rays!: Sprite;
  bigHeart!: Sprite;
  infinitySymbol!: Sprite;
  winStreakIconSlot!: Container;
  upperCase_SPL!: (Text)[];
  StateName!: 'unlimitedLives';

  constructor() {
    populate(this, raw);
  }
}
